/* eslint-disable no-magic-numbers */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './TechnicalReport.APP_TARGET.scss';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { WEBP_SVG_TYPE, X } from 'Constants/images';
import ToolTip from 'Components/ToolTip/ToolTip';

export class TechnicalTabContent extends React.PureComponent {
    static propTypes = {
        value: PropTypes.object.isRequired
    };

    getToolTipImage = item => {
        if (item.statusImageURI) {
            const statusImage = (<ImageWrapper
                fileName={ item.statusImageURI }
                fileSize={ X }
                types={ WEBP_SVG_TYPE }
                className={ css.statusImage }
            />);

            if (item.defectReason) {
                return (<ToolTip
                    tooltip={ item.defectReason }
                >
                    {statusImage}
                </ToolTip>
                );
            }

            return statusImage;
        }

        return <div className={ css.noImage } />;
    }

    getSectionContent = section => {
        return (
            <div className={ css.sectionContent }>
                { section.items && section.items.map(item => {
                    return (<li key={ item.id } className={ css.valueList }>
                        <ToolTip
                            tag="div"
                            className={ css.itemName }
                            tooltip={ item.name }
                        >
                            <span className={ classNames(css.sectionSpan, { [css.itemNameWithDefect]: item.defectReason }) }>{item.name}</span>
                        </ToolTip>
                        <div className={ css.itemName } data-tooltip={ item.name } />
                        <div className={ css.itemStatus }>
                            {
                                !!item.defectReason
                                && <span className={ css.itemDefectReason }>{item.defectReason}</span>
                            }

                            {this.getToolTipImage(item)}
                        </div>
                    </li>);
                })}
            </div>
        );
    };

    getClassName = (sections = []) => {
        switch (sections.length) {
            case 0 : return null;
            case 1 : return css.oneCol;
            case 2 : return css.twoCol;
            case 3 : return css.threeCol;
            default: return null;
        }
    }

    render() {
        const { value } = this.props;
        const sectionClassName = this.getClassName(value.sections);

        return (
            <div className={ css.sectionContainer }>
                {value.sections && value.sections.map(section => {
                    const hasItemValue = section.items
                    && section.items.some(item => item.values && item.values.length > 0);

                    return (
                        <div key={ section.id } className={ classNames(css.sectionWrapper, sectionClassName) }>
                            <div className={ css.sectionSummary }>
                                <div className={ css.sectionTitle }>{ section.name }</div>
                                { section.summaryText && <span>{ section.summaryText }</span> }
                            </div>
                            { hasItemValue && this.getSectionContent(section) }
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default TechnicalTabContent;
